import { Node } from '@tiptap/core';
import { Editor } from '@tiptap/react';
import ReactDOMServer from 'react-dom/server';

import { fetchMetadata } from '@/utilities';

import CustomLinkEmbed from './CustomLinkEmbed';

export default class LinkEmbed extends Node {
    editor!: Editor;

    constructor() {
        super();
    }

    get nodeName() {
        return 'linkEmbed';
    }

    defaultOptions() {
        return {
            fetchMetadata: async () => ({}), // default fetchMetadata function
        };
    }

    get schema() {
        return {
            attrs: {
                href: {},
                title: { default: null },
                description: { default: null },
                image: { default: null },
                metadata: { default: null },
            },
            inline: true,
            group: 'inline',
            selectable: false,
            parseDOM: [
                {
                    tag: 'div[data-link-embed]',
                    getAttrs: (dom: any) => ({
                        href: dom.getAttribute('data-href'),
                        title: dom.getAttribute('data-title'),
                        description: dom.getAttribute('data-description'),
                        image: dom.getAttribute('data-image'),
                    }),
                },
            ],
            toDOM: (node: any) => [
                'div',
                {
                    'data-link-embed': '',
                    'data-href': node.attrs.href,
                    'data-title': node.attrs.title,
                    'data-description': node.attrs.description,
                    'data-image': node.attrs.image,
                },
                0,
            ],
        };
    }

    async createLinkNode(href: any, title: any, description: any, image: any) {
        const content = ReactDOMServer.renderToString(
            <CustomLinkEmbed href={href} title={title} description={description} image={image} />,
        );
        return this.editor?.chain().insertContent(content).run();
    }

    async getLinkNodeAttrs(href: any) {
        const metadata = await fetchMetadata(href);
        const title = metadata?.openGraph?.title;
        const description = metadata?.openGraph?.description;
        const image = metadata?.openGraph?.image?.url;
        return { href, title, description, image };
    }

    async insertLink(href: any) {
        const { href: finalHref, title, description, image } = await this.getLinkNodeAttrs(href);
        await this.createLinkNode(finalHref, title, description, image);
    }

    commands({ type }: any) {
        return {
            insertLink: (href: any) => () => this.insertLink(href),
        };
    }
}
